export default __webpack_public_path__ + "static/media/HK Mittal.57a705d6.png";